import * as React from 'react';
import './LoadingOverlay.css';

interface ProgressOverlayProps {
  visible: boolean;
}

class LoadingOverlay extends React.Component<ProgressOverlayProps> {

  public render(): React.ReactNode {
    const visbleCls = this.props.visible ? 'visible' : '';
    return (
      <div className={`loading-overlay ${visbleCls}`}>
        <div className="ant-spin ant-spin-spinning">
          <span className="ant-spin-dot ant-spin-dot-spin">
            <i className="ant-spin-dot-item"/>
            <i className="ant-spin-dot-item"/>
            <i className="ant-spin-dot-item"/>
            <i className="ant-spin-dot-item"/>
          </span>
        </div>
      </div>
    );
  }
}

export default LoadingOverlay;


// WEBPACK FOOTER //
// ./src/common/LoadingOverlay.tsx